/* RESPONSIBLE TEAM: team-omni */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import type Session from 'embercom/services/session';
import type DiscordIntegrationModel from 'embercom/models/discord/integration';

export default class DiscordIntegrationService extends Service {
  @service declare store: Store;
  @service declare session: Session;

  @tracked discordIntegration: DiscordIntegrationModel | null = null;

  async loadIntegration(): Promise<void> {
    if (!this.session.workspace.isFeatureEnabled('discord-channel')) {
      return;
    }

    try {
      this.discordIntegration = await this.store.queryRecord('discord/integration', {
        app_id: this.session.workspace.id,
      });
    } catch (error) {
      console.error('Error loading Discord integration:', error);
      this.discordIntegration = null;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'discord-integration-service': DiscordIntegrationService;
  }
}
